import { render } from "./BagRecordingDownloader.vue?vue&type=template&id=37b007da&scoped=true&ts=true"
import script from "./BagRecordingDownloader.vue?vue&type=script&lang=ts"
export * from "./BagRecordingDownloader.vue?vue&type=script&lang=ts"

import "./BagRecordingDownloader.vue?vue&type=style&index=0&id=37b007da&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b007da"]])

export default __exports__